import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import { createRouteFromReactElement } from 'react-router/lib//RouteUtils';

import { hasAuthority } from 'app/dealer/utils';

export class GuardedRoute extends React.PureComponent {
  render() {
    return (
      <div>
        &lt;GuardedRoute&gt; elements are for configuration only and should not
        be rendered
      </div>
    );
  }
}

GuardedRoute.createRouteFromReactElement = (element) => {
  const {
    children,
    component,
    components,
    getComponent,
    getComponents,
    getState,
    path,
    redirectTo,
    requiredAuthorities,
  } = element.props;

  const onEnter = (nextState, replace) => {
    const {
      authorities: { authorities },
    } = getState();

    /**
     *  Or we skip to this part and allow the user through
     *  if they have the required authorities.
     */
    if (hasAuthority(authorities, requiredAuthorities)) {
      return true;
    }

    /**
     *  Or we redirect them where they are meant to go in
     *  all other cases
     */
    return replace({
      pathname: redirectTo,
      query: {
        nextPath: nextState.location.pathname,
      },
    });
  };

  return createRouteFromReactElement(
    <Route
      component={component}
      components={components}
      getComponent={getComponent}
      getComponents={getComponents}
      onEnter={onEnter}
      path={path}
    >
      {children}
    </Route>
  );
};

GuardedRoute.propTypes = {
  component: PropTypes.oneOf([PropTypes.func, PropTypes.object]),
  components: PropTypes.array,
  getComponent: PropTypes.func,
  getComponents: PropTypes.func,
  getState: PropTypes.func.isRequired,
  path: PropTypes.string,
  requiredAuthorities: PropTypes.arrayOf(PropTypes.string),
  redirectTo: PropTypes.string,
};

GuardedRoute.defaultProps = {
  component: null,
  getComponent: () => {},
  getComponents: () => {},
  path: '',
  redirectTo: '/dealer/login',
  requiredAuthorities: [],
};
